import React, { useEffect } from 'react';
import { fetchStatesDataOfIndia, fetchDistrictDataOfState } from '../actions/action';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';


function StateBy(props) {

  const dispatch = useDispatch();
  const districtsData = useSelector(state => state.districtsData);
  const indiaStatesData =  useSelector(state => state.indiaStatesData);
  var filteredDistrictData;
  var route;

  if(props.match.params.statename.includes("-")) {
    route = props.match.params.statename.split("-").join(" ")
    filteredDistrictData = districtsData[route];
  } else {
    route = props.match.params.statename;
    filteredDistrictData = districtsData[route];
  }

  
  let filteredIndiaStatesData = indiaStatesData.filter(data => data.state === route);

  // useEffect(() => {
  //   dispatch(fetchStatesDataOfIndia());
  //   dispatch(fetchDistrictDataOfState());
  // });

  dispatch(fetchStatesDataOfIndia());
  dispatch(fetchDistrictDataOfState());

  return (
    <div className="App">
      <div style={{marginTop: '10px', marginBottom: '10px'}}>
        <Link style={{ marginLeft: '10px'}} className="btn" to="/">Back</Link>
      </div>
      {
        (filteredIndiaStatesData[0]) ? 
        <div>
          <p style={{margin: '10px', fontSize: '1.2rem'}}>{props.match.params.statename} Status</p>
          <div className="d-f fw-w center">
            <div className="main-card b-blue">
              <p style={{color: '#6980ff', fontWeight: 600}}>Confirmed</p>
              <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{filteredIndiaStatesData[0].confirmed}</p>
            </div>
            <div className="main-card b-yellow">
              <p style={{color: 'rgb(192, 174, 12)', fontWeight: 600}}>Active</p>
              <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.2rem'}}>{filteredIndiaStatesData[0].active}</p>
            </div>
            <div className="main-card b-green">
              <p style={{color: 'rgba(70, 194, 16, 0.93)', fontWeight: 600}}>Recovered</p>
              <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{filteredIndiaStatesData[0].recovered}</p>
            </div>
            <div className="main-card b-red">
              <p style={{color: 'rgba(199, 14, 14, 0.883)', fontWeight: 600}}>Deaths</p>
              <p style={{color: '#3d3f3dd1', fontWeight: 700, fontSize: '1.1rem'}}>{filteredIndiaStatesData[0].deaths}</p>
            </div>
          </div>
        </div> : ''
      }

      <ul>
        <li key="99" className="list-item">
          Districs 
          <span>
            <span style={{color: '#6980ff', fontWeight: 600, marginRight: '25px'}}>Confirmed</span>
            <span style={{color: 'rgb(192, 174, 12)', fontWeight: 600, marginRight: '15px'}}>Active</span>
          </span>
        </li>
        {
          (filteredDistrictData && filteredDistrictData.districtData) ? 
          Object.entries(filteredDistrictData.districtData).map((dist, idx) => {
            return (<li key={idx} className="list-item li-item">
              {dist[0]} 
              <span>
                <span style={{color: '#6980ff', fontWeight: 600, marginRight: '25px'}}>{dist[1].confirmed}</span>
                <span style={{color: 'rgb(192, 174, 12)', fontWeight: 600, marginRight: '15px'}}>{dist[1].active}</span>
              </span>
            </li>)
          }) :  <div className="center mt-20"><div className="lds-dual-ring"></div></div>
        }
      </ul>
    </div>
  );
}

export default StateBy;
